import React from 'react';
import { SvgIcon } from '@material-ui/core';
const Search = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { viewBox: "0 0 24 24", width: "24", height: "24", fill: "none" }),
    React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { cx: "10", cy: "10", r: "7.75", stroke: "#794BFF", strokeWidth: "1.5" }),
        React.createElement("path", { d: "M16 16L21 21", stroke: "#794BFF", strokeWidth: "1.5", strokeLinecap: "round" }))));
export default Search;
